<template lang="jade">
	
    .asw-hexhover(v-if="properties")
        //-transition(appear, name="fade", mode="out-in")
        .asw-hexhover-electorate
            |{{ properties.Elect_div }}, {{ properties.electorate_state }}
        .asw-hexhover-locations
            |{{'Localities include'}} {{ properties.electorate_locations }}
</template>
<script>

	export default {
		name: "hexhover",
		props: {
			hexHoverData: {
				type: Object
			}
		},
		data: () => ({
            
		}),
		computed: {
            properties() {
				return this.hexHoverData.properties;
			}
		},
		mounted() {
			// console.log('Hover',this);
		},
		methods: {
			
		}
	}
</script>
<style lang="scss">
	@import "src/assets/scss/global-sass";

	.asw-hexhover {
        position:fixed;
        border: 1px solid #d3d3d3;
        background: #000;
        border-radius: 5px;
        padding:10px 20px;
        width:200px;
        height:95px;
        z-index: 20;

		@include MQ_LargeOnly() {

		}

		@include MQ_SmallMedium() {
			
        }
        
        &-electorate {
            color:#1691D9;
            font-size:1.1em;
            //font-weight: 700;
        }

        &-locations {
            color:#fff;
            font-size:0.8em;
            line-height:1.2em;
        }

	}
</style>



// WEBPACK FOOTER //
// src/components/HexHover.vue